import React from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column, InputText, Dialog, Toast } from "primereact";
import MultiLanguageDialog from "../MultiLanguageDialog";
import "../../assets/css/badge.css";
import { initValue } from "../../util";

class ListaCertificazioni extends React.Component {
  constructor() {
    super();
    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (id) => {
          this.vai(id, "V");
          console.log("View " + id);
        },
      },
      {
        id: 2,
        icon: "pi-pencil",
        label: "",
        action: (id) => {
          this.vai(id, "U");
          console.log("Update " + id);
        },
      },
      {
        id: 3,
        icon: "pi-trash",
        label: "",
        action: (id) => {
          this.vai(id, "D");
          console.log("Delete " + id);
        },
      },
    ];
    this.state = {
      activePage: 0,
      lista: [],
      totalRecords: 0,
      first: 0,
      rows: 10,
      loading: true,
      visible1: false,
    };

    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.state = {
      xcarica: "sezione",
      imgsrc: "",
      imgsrcen: "",
      dati: [],
      activePage: 1,
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      visible2: false,
      visible3: false,
      singolo: {},
    };
    this.onPage = this.onPage.bind(this);
    this.prodottoid = 0;
    this.certificatoid = 0;
    this.tipo = 0;
    this.hasImage = false;
  }

  settaImg() {
    var testo =
      Costanti.UrlCallApi +
      "file/get/" +
      this.utente.aziendaid +
      "/certificato/" +
      this.certificatoid +
      "?" +
      Math.random();
    var testoen =
      Costanti.UrlCallApi +
      "file/get/" +
      this.utente.aziendaid +
      "/certificatoen/" +
      this.certificatoid +
      "?" +
      Math.random();
    this.setState({ imgsrc: testo, imgsrcen: testoen });
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  componentDidMount() {
    this.prodottoid = this.props.prodottoid ? this.props.prodottoid : -1;

    this.aggiungi = false;
    if (this.props.match) {
      if (JSON.stringify(this.props.match.url).endsWith('aziendali"')) {
        this.tipo = 1;
        this.aggiungi = true;
      }
      if (JSON.stringify(this.props.match.url).endsWith('prodotti"')) {
        this.tipo = 2;
        this.aggiungi = true;
      }
    } else {
      this.tipo = 2;
    }

    this.caricaDati(1, this.state.pageSize);
  }

  caricaDati(pagina, numrec) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    var quer =
      "page=" +
      pagina +
      "&num=" +
      numrec +
      "&aziendaid=" +
      this.utente.aziendaid +
      "&idcollegato=" +
      (this.prodottoid == 0 ? -1 : this.prodottoid) +
      "&tipo=" +
      this.tipo;
    axios
      .get(Costanti.UrlCallApi + "certificazione/all?" + quer, config)
      .then((res) => {
        res.data.lista1.forEach((element) => {
          element.azioni = this.actions;
        });

        const rowItemVal = [];
        const traduzioneArray = res.data.lista1.map((item) => item.traduzione);
        const certificazioniIdArray = res.data.lista1.map((item) => ({ id: item.id, hasImage: item.hasImage }));
        traduzioneArray.forEach((el, index) => {
          const filteredValue = el.filter((item) => item.lingua === "it");
          const nome = filteredValue.find((item) => item.nomecampo === "nome");
          const descrizione = filteredValue.find((item) => item.nomecampo !== "nome");
          const fieldValue = {
            nome: nome ? nome.testo : "",
            descrizione: descrizione ? descrizione.testo : "",
            id: certificazioniIdArray[index].id,
            hasImage: certificazioniIdArray[index].hasImage,
          };
          rowItemVal.push(fieldValue);
        });

        this.setState({
          dati: rowItemVal.length > 0 ? rowItemVal : undefined,
          totalRecords: res.data.conta1,
          loading: false,
        });

        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  caricaSingolo(id, tipo) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    axios
      .get(Costanti.UrlCallApi + "certificazione/" + id, config)
      .then((res) => {
        this.setState({ singolo: res.data, loading: false });
        this.certificatoid = id;
        this.hasImage = res.data.hasImage;
        this.settaImg();
      })
      .catch((error) => {
        this.certificatoid = 0;
        alert(error);
      });
  }

  setVisible1(val) {
    this.setState({ visible1: val });
    this.caricaDati(this.state.activePage, this.state.pageSize);
  }

  vai(id, tipo) {
    if (id !== 0) {
      this.caricaSingolo(id);
    }
    this.setVisible1(true);
    this.setState({ tipo: tipo });
    switch (tipo) {
      case "A":
        this.setState({ editMode: true, singolo: {}, intestazione: "Aggiungi Certificazione" });
        break;
      case "V":
        this.setState({ intestazione: "Visualizza Certificazione" });
        break;
      case "D":
        this.setState({ intestazione: "Elimina Certificazione" });
        break;
      case "U":
        this.setState({ editMode: true, intestazione: "Modifica Certificazione" });
        break;
    }
  }

  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }

  setPDF(value) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/certificazioni/" + this.prodottoid, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }

  render() {
    return (
      <div>
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>
        <DataTable
          emptyMessage={<div className="flex w-full justify-content-center font-bold ">NO DATA FOUND</div>}
          value={this.state.dati}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">{`Lista certificazioni ${
                this.props.match.url.endsWith("aziendali") ? "aziendali" : "prodotti"
              }`}</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />
              <div className="flex flex-row gap-3">
                <Button
                  label="Esporta in Pdf"
                  onClick={() => this.setPDF(true)}
                  icon="pi pi-file-pdf"
                  className="p-button-rounded p-button-danger "
                />

                <Button
                  label="Aggiungi"
                  onClick={() => this.vai(0, "A")}
                  icon="pi pi-plus"
                  className="p-button-rounded p-button-primary "
                />
              </div>
            </div>
          }
          responsiveLayout="stack"
        >
          <Column
            id="id0"
            header=""
            body={(item) => (
              <a
                href={Costanti.UrlCallApi + "file/get/" + this.utente.aziendaid + "/certificato/" + item.id}
                target="_blank"
              >
                {item.hasImage ? <img src="assets/layout/images/download.png" width={"25%"} /> : ""}{" "}
              </a>
            )}
          />
          <Column id="id1" field="nome" header="Nome" />
          <Column id="id2" field="descrizione" header="Descrizione" />

          <Column
            id="id5"
            field="id"
            header="Azioni"
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {this.actions.map((action) => (
                  <Button
                    key={action.id}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>
        {((this.state.singolo && Object.keys(this.state.singolo).length > 0) || this.state.tipo === "A") && (
          <MultiLanguageDialog
            hasImage={true}
            title={this.state.intestazione}
            isVisible={this.state.visible1}
            operationType={this.state.tipo}
            itemId={this.state.singolo.id}
            contents={this.state.singolo}
            initValue={initValue}
            onClose={() => this.setVisible1(false)}
            label={["Nome", "Descrizione"]}
            itemToAdd={{
              datains: null,
              dataupd: null,
              id: 0,
              tipo: this.tipo,
              idcollegato: this.prodottoid,
              aziendaid: this.utente.aziendaid,
              uteins: 1,
              uteupd: null,
              status: " ",
            }}
            table={"certificazione"}
          />
        )}
      </div>
    );
  }
}

export default ListaCertificazioni;
